import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";
import classNames from "classnames";
import styles from "./MessengersBlock.module.scss";
import { FixButton } from "@/elements-react/fix-button";
import { Icon } from "@/elements-react/fix-icon";
import whatsappIcon from "@/assets/whatsapp-line.svg";
import { useServices } from "@/services-context.tsx";
import { useTranslation } from "react-i18next";
import React, { useCallback } from "preact/compat";

export interface MessengersBlockProps {
  productMpn: string;
}

export const MessengersBlock: React.FC<MessengersBlockProps> = ({ productMpn }) => {
  const { layoutType } = useLayoutType();
  const { customerChannel, formatter } = useServices();
  const { t } = useTranslation();

  if (!customerChannel.whatsappPhone) {
    return null;
  }

  const handleClick = useCallback(() => {
    const encodedMessage = encodeURIComponent(
      t("nayfuo9p34wgf9as.have-a-question-product", "Hello! I have a question about your products", { mpnProduct: productMpn }),
    );
    const encodedPhone = formatter.phoneCleaner(customerChannel.whatsappPhone!);

    window.open(`https://wa.me/${encodedPhone}?text=${encodedMessage}`, "_blank");
  }, [customerChannel.whatsappPhone]);

  return (
    <div className={classNames(styles.root, layoutType === LayoutTypes.TYPE_DESKTOP && styles.desktop)}>
      <div>
        <div className={styles.title}>{t("bfa78v7eig5bgw78.need-help", "Need help or have a question?")}</div>
        <div className={styles.subTitle}>{t("av87a4wgfan8na98.help-you-find", "We’ll help you find what you need")}</div>
      </div>
      <FixButton className={styles.button} labelClassName={classNames(styles.buttonLabelClassName, styles.buttonTextColor)} onClick={handleClick}>
        <Icon height={24} width={24} src={whatsappIcon} /> {t("wbf89weiaurgbv9r.chat-on-whatsapp", "Chat on WhatsApp")}
      </FixButton>
    </div>
  );
};
